export default "__VITE_ASSET__QvTrnWak__"